//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";

export default {
  name: "TeamMemberListPage",
  components: { HiCell, HiHeader },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
  methods: {
    /**
     * 点击跳转到member设置页面
     */
    memberDetailClick(item) {
      this.$router.push({
        name: "MyPlanMemberDetailPage",
        params: { id: item.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/team_member/List.vue